export default "__VITE_ASSET__3aa59714__"